import NAME from "./constants";

export const getLoading = store => store[NAME].isLoading;
export const getData = store => store[NAME].data;
export const getTypes = store => store[NAME].types;
export const getHolidayTypes = store => store[NAME].holidayTypes;
export const getEstablishmentTypes = store => store[NAME].establishmentTypes;
export const getRiskCenters = store => store[NAME].riskCenters;